'use client';

import { PathInterface } from '@qlevr/shared/interfaces';
import React, { createContext, useContext, useState } from 'react';

interface LocalisationProviderProps {
  children: React.ReactNode;
}

interface LocalisationProviderContextType {
  localisation: PathInterface[] | null;
  setLocalisation: (localisation: PathInterface[] | null) => void;
}

export const LocalisationProviderContext = createContext<LocalisationProviderContextType>({
  localisation: null,
  setLocalisation: () => {},
});

export const LocalisationProvider: React.FC<LocalisationProviderProps> = ({ children }) => {
  const [localisation, setLocalisation] = useState<PathInterface[] | null>(null);

  return (
    <LocalisationProviderContext.Provider value={{ localisation, setLocalisation }}>
      {children}
    </LocalisationProviderContext.Provider>
  );
};

export const useLocalisation = () => {
  const context = useContext(LocalisationProviderContext);
  if (context === undefined) {
    throw new Error('LocalisationProviderContext must be used within a LocalisationProvider');
  }
  return context;
};
